import React from 'react'
import { Outlet } from 'react-router-dom'

const Web3DepositComponent = () => {
  return (
    <div>
        <Outlet/>
    </div>
  )
}

export default Web3DepositComponent
